import { render, staticRenderFns } from "./ChatIcon.vue?vue&type=template&id=6e62a062&scoped=true"
import script from "./ChatIcon.vue?vue&type=script&lang=js"
export * from "./ChatIcon.vue?vue&type=script&lang=js"
import style0 from "./ChatIcon.vue?vue&type=style&index=0&id=6e62a062&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62a062",
  null
  
)

export default component.exports